import Vue from "vue";
import { env } from "./env";

const mixins = {
	data() {
		return { env };
	},
	metaInfo() {
		return {
			link: [
				{
					rel: "canonical",
					href: `${this.env.desktopUrl}/${this.env.locale}${
						this.$route ? this.$route.path : ""
					}`.toLowerCase(),
				},
			],
		};
	},
	methods: {
		productAvailable(product) {
			return env.availableProducts.includes(product);
		},
	},
};
Vue.mixin(mixins);
